import api from "@/core/api";

export const mainMenu = () => api.query(`/system/mainmenu`);
export const constants = () => api.query(`/system/constants`);
export const numerator = (data: any) => api.query(`/system/numerator`, { data, method: "put" });
